/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "../../../examples/Navbars/DefaultNavbar";
import DefaultFooter from "../../../examples/Footers/DefaultFooter";

// About page sections
import About from "./sections/About";
import Featuring from "./sections/Featuring";
import Information from "./sections/Information";
import Contact from "./sections/Contact";

// Routes
import routes from "../../../routes";
import footerRoutes from "../../../footer.routes";

// Images (page-specific photo + shared dark gradient overlay in sx below)
import bgImage from "../../../assets/images/fabio-unsplash.jpeg";

import { useAuthenticator } from "@aws-amplify/ui-react";

function AboutWednesdayCoin() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const navAction =
    authStatus !== "authenticated"
      ? {
          type: "internal",
          route: "/projects/sign-in",
          label: "sign in",
          color: "info",
        }
      : {
          type: "internal",
          route: "/projects/sign-out",
          label: "sign out",
          color: "info",
        };

  return (
    <MKBox
      sx={{
        minHeight: "100vh",
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <DefaultNavbar routes={routes} action={navAction} sticky />
      {/* DefaultNavbar inner bar is position:absolute — pad enough to clear it */}
      <Container sx={{ pt: { xs: 12, sm: 14, md: 15 }, pb: 4 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={10} xl={9}>
            <Card
              sx={({ palette: { white }, functions: { rgba }, borders: { borderRadius }, boxShadows }) => ({
                p: { xs: 2, sm: 3 },
                backgroundColor: rgba(white.main, 0.95),
                backdropFilter: "saturate(200%) blur(24px)",
                boxShadow: boxShadows.lg,
                borderRadius: borderRadius.lg,
              })}
            >
              <MKTypography
                variant="h1"
                color="dark"
                textAlign="center"
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Because Wednesday!
              </MKTypography>
              <MKTypography
                variant="body1"
                color="text"
                textAlign="center"
                sx={{ opacity: 0.85 }}
                px={{ xs: 0, sm: 2 }}
                mb={3}
              >
                Welcome to WednesdayCoin, the ERC20 Token that can only be used on Wednesdays! I started this as a way
                to learn about Solidity and smart contract development and it has grown to something bigger, with a great
                community behind it!
              </MKTypography>
              <MKTypography
                variant="body1"
                color="text"
                textAlign="center"
                sx={{ opacity: 0.85 }}
                px={{ xs: 0, sm: 2 }}
                mb={4}
              >
                I have always liked the idea of a super niche (specialized) coin and was spending way too much time
                checking out the prices of crypto so I figured WednesdayCoin could be a great way to detach from the 24/7
                crypto world (^_^)
              </MKTypography>
              <About />
              <Featuring />
              <Information />
              <Contact />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <MKBox
        component="footer"
        sx={({ palette: { white } }) => ({
          backgroundColor: white.main,
          pt: 6,
          pb: 2,
          mt: 4,
        })}
      >
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

export default AboutWednesdayCoin;
